export const ChangeSelectedStore = "ChangeSelectedStore";
